import React, { Component } from 'react';
import Loading from '../../Loading.js'
import { getMessage } from '../../../Api/ExtranetActions.js';

declare var globalExtranet;
declare var $;

class ControlMessageDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    componentWillMount() {
        this.loadData();
    }

    loadData() {
        getMessage(this.props.historyId, this.props.messageId, (data) => {
            this.setState({
                data: data
            });
        });
    }

    render() {
        if (this.state.data == null) {
            return (
                <Loading/>
            );
        }

        return (
            <div className="messageDetail">
                <div dangerouslySetInnerHTML={{ __html: this.state.data.body }} />
                <ul>
                    {
                        this.state.data.attachments.map((x) =>
                            <li key={x.id}>
                                <a className="subcatlink" href={globalExtranet.extranetDocumentsUrl + "?id=" + x.id} target="_blank">
                                    <i className="fa fa-search" aria-hidden="true"></i> {x.name}
                                </a>                                
                            </li>
                        )
                    }
                </ul>
            </div>
            
        );
    }
}

export default ControlMessageDetail;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlMessageDetail.js